import { memo } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import DateRangePicker from '../../DateRangePicker';
import moment from 'moment';

const OncologyHistory = ({ selectedData, setSelectedHistories }) => {
  const updateOncologyData = (fieldName, val) => {
    if (!selectedData['oncology']) {
      selectedData['oncology'] = {};
    }

    selectedData['oncology'][fieldName] = val;
    setSelectedHistories({ ...selectedData });
  };

  return (
    <>
      <Row className="px-1">
        <Col md="3" className="font-weight-bold mt-1">
          Chemotherapy:
        </Col>
        <Col md="9">
          <Form.Control
            as="textarea"
            rows={2}
            placeholder="Chemotherapy"
            defaultValue={selectedData?.oncology?.chemoTherapyNotes}
            onChange={(e) =>
              updateOncologyData('chemoTherapyNotes', e.target.value)
            }
          />
        </Col>
      </Row>
      <Row>
        <Col md={3}></Col>
        <Col md={9}>
          <DateRangePicker
            placeholder="Select date"
            onChange={(start, end) => {
              const formatedStartDate = moment(start).format('DD/MM/YY');
              const formatedEndDate = moment(end).format('DD/MM/YY');
              if (formatedEndDate === formatedStartDate) {
                updateOncologyData('chemoTherapyDate', formatedStartDate);
              } else {
                updateOncologyData(
                  'chemoTherapyDate',
                  `${formatedStartDate}-${formatedEndDate}`,
                );
              }
            }}
          />
        </Col>
      </Row>
      <Row className="mt-1 px-1">
        <Col md="3" className="font-weight-bold mt-1">
          Radiotherapy:
        </Col>
        <Col md="9">
          <Form.Control
            as="textarea"
            rows={2}
            placeholder="Radiotherapy"
            defaultValue={selectedData?.oncology?.radioTherapyNotes}
            onChange={(e) =>
              updateOncologyData('radioTherapyNotes', e.target.value)
            }
          />
        </Col>
      </Row>
      <Row>
        <Col md={3}></Col>
        <Col md={9}>
          <DateRangePicker
            placeholder="Select date"
            onChange={(start, end) => {
              const formatedStartDate = moment(start).format('DD/MM/YY');
              const formatedEndDate = moment(end).format('DD/MM/YY');
              if (formatedEndDate === formatedStartDate) {
                updateOncologyData('radioTherapyDate', formatedStartDate);
              } else {
                updateOncologyData(
                  'radioTherapyDate',
                  `${formatedStartDate}-${formatedEndDate}`,
                );
              }
            }}
          />
        </Col>
      </Row>
      <Row className="mt-1 px-1">
        <Col md="3" className="font-weight-bold mt-1">
          Hormonal Therapy:
        </Col>
        <Col md="9">
          <Form.Control
            as="textarea"
            rows={2}
            placeholder="Hormonal Therapy"
            defaultValue={selectedData?.oncology?.hormonalTherapyNotes}
            onChange={(e) =>
              updateOncologyData('hormonalTherapyNotes', e.target.value)
            }
          />
        </Col>
      </Row>
      <Row>
        <Col md={3}></Col>
        <Col md={9}>
          <DateRangePicker
            placeholder="Select date"
            onChange={(start, end) => {
              const formatedStartDate = moment(start).format('DD/MM/YY');
              const formatedEndDate = moment(end).format('DD/MM/YY');
              if (formatedEndDate === formatedStartDate) {
                updateOncologyData('hormonalTherapyDate', formatedStartDate);
              } else {
                updateOncologyData(
                  'radioTherapyDate',
                  `${formatedStartDate}-${formatedEndDate}`,
                );
              }
            }}
          />
        </Col>
      </Row>
      <Row className="mt-1 px-1">
        <Col md="3" className="font-weight-bold mt-1">
          Surgery:
        </Col>
        <Col md="9">
          <Form.Control
            as="textarea"
            rows={2}
            placeholder="Surgery"
            defaultValue={selectedData?.oncology?.notes}
            onChange={(e) => updateOncologyData('surgeryNotes', e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col md={3}></Col>
        <Col md={9}>
          <DateRangePicker
            placeholder="Select date"
            onChange={(start, end) => {
              const formatedStartDate = moment(start).format('DD/MM/YY');
              const formatedEndDate = moment(end).format('DD/MM/YY');
              if (formatedEndDate === formatedStartDate) {
                updateOncologyData('surgeryDate', formatedStartDate);
              } else {
                updateOncologyData(
                  'surgeryDate',
                  `${formatedStartDate}-${formatedEndDate}`,
                );
              }
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default memo(OncologyHistory);
